import LoginView from '../../views/LoginView.vue';
import { useUserStore } from '@/store/user';

/**
 * Navigation guard to redirect authenticated users away from login pages
 * Simply checks userStore.isAuthenticated (which checks timerId)
 * Backend session validation happens via timer in userStore
 * 
 * @param {Object} to - Target route
 * @param {Object} from - Current route
 * @param {Function} next - Navigation callback
 */
const redirectIfAuthenticated = (to, from, next) => {
  const userStore = useUserStore();
  if (!!userStore.accesslevel) {
    next({ path: '/profile' });
  } else {
    next();
  }
};

export default [
  {
    path: '/login/:path*',
    name: 'Login',
    component: LoginView,
    beforeEnter: redirectIfAuthenticated,
    meta: {
      hideHeader: true,
      hideInactivityTracker: true
    }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/login'
  }
];
